import { AccountInformation } from '@almamedia-legal-insights/types';

interface FeatureFlagProps {
  flagName: string;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useFeatureFlag(
  flagName: string,
  authInfo?: AccountInformation,
): boolean {
  return authInfo?.featureFlags?.includes(flagName) ?? false;
}

export function FeatureFlag({
  flagName,
  fallback,
  authInfo,
  children,
}: FeatureFlagProps & { authInfo?: AccountInformation }) {
  const hasFlag = useFeatureFlag(flagName, authInfo);
  return hasFlag ? children : (fallback ?? null);
}
